import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconHighlightPen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M27.4177 17.6136L22.9732 13.1691L25.5994 10.5429C25.99 10.1524 26.6231 10.1524 27.0137 10.5429L30.0439 13.5731C30.4344 13.9636 30.4344 14.5968 30.0439 14.9873L27.4177 17.6136ZM26.3066 18.725L17.1955 27.8361H15.751L12.751 24.8361V23.3917L21.8621 14.2805L26.3066 18.725ZM12.251 25.75L14.751 28.25L13.3975 29.6036C13.3037 29.6973 13.1765 29.75 13.0439 29.75H10.6652C9.77432 29.75 9.32816 28.6729 9.95812 28.0429L12.251 25.75Z",
		fill: "#707070"
	})
});
export default SvgIconHighlightPen;
